/* MEADOW GIFT - product gallery.

   The gallery is a native horizontal scroller with CSS scroll snapping, not a
   JavaScript drag. On a phone that matters: the finger gets real momentum,
   rubber-banding at the ends, and the browser's own frame pacing, none of
   which a pointer-event shim reproduces convincingly. It also degrades well -
   if this file fails to load the photos are still swipeable, only the dots
   stop updating.

   This file keeps four things in sync:
     scroll position <-> data-index <-> dots <-> thumbnails

   mg-theme.js already writes data-index when a thumbnail, an arrow, or a
   fully resolved variant is chosen, so rather than duplicating those listeners
   we watch the attribute and scroll to match. Colour is handled separately
   because a colour on its own does not resolve a variant when the size is
   still unchosen, so mg-theme.js stays silent and the photo would never move. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slides(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.mg-gal__slide'));
  }

  function lightboxSlides(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.mg-gallery-lightbox__slide'));
  }

  function scrollIndex(track) {
    var w = track.clientWidth || 1;
    var n = slides(track).length;
    return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
  }

  function stated(gal) {
    return parseInt(gal.getAttribute('data-index'), 10) || 0;
  }

  /* Paint the index everywhere except the scroller itself. */
  function paint(gal, idx) {
    if (stated(gal) !== idx) gal.setAttribute('data-index', String(idx));

    var thumbs = gal.querySelectorAll('[data-mg-thumb]');
    Array.prototype.forEach.call(thumbs, function (t, i) {
      t.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    Array.prototype.forEach.call(gal.querySelectorAll('[data-mg-dot]'), function (d, i) {
      d.setAttribute('data-on', i === idx ? 'true' : 'false');
    });
    var current = gal.querySelector('[data-mg-gallery-current]');
    if (current) current.textContent = String(idx + 1);

    var strip = gal.querySelector('.mg-gal__thumbs');
    var thumb = thumbs[idx];
    if (strip && thumb && strip.scrollWidth > strip.clientWidth + 4) {
      var tr = thumb.getBoundingClientRect();
      var sr = strip.getBoundingClientRect();
      if (tr.left < sr.left + 2 || tr.right > sr.right - 2) {
        strip.scrollTo({
          left: strip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }
    }
  }

  function glide(track, idx, instant) {
    track.scrollTo({
      left: idx * track.clientWidth,
      behavior: instant || reduced ? 'auto' : 'smooth'
    });
  }

  function goTo(gal, track, idx) {
    paint(gal, idx);
    if (idx !== scrollIndex(track)) glide(track, idx);
  }

  function wrap(idx, count) {
    return (idx + count) % count;
  }

  function lightboxIndex(track) {
    var w = track.clientWidth || 1;
    var n = lightboxSlides(track).length;
    return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
  }

  function paintLightbox(lightbox, idx) {
    lightbox.setAttribute('data-index', String(idx));
    var current = lightbox.querySelector('[data-mg-lightbox-current]');
    if (current) current.textContent = String(idx + 1);
  }

  function glideLightbox(track, idx, instant) {
    track.scrollTo({
      left: idx * track.clientWidth,
      behavior: instant || reduced ? 'auto' : 'smooth'
    });
  }

  /* ---- colour picks the photo ---------------------------------------- */

  function isColour(name) {
    var n = String(name || '').toLowerCase();
    return n === 'color' || n === 'colour';
  }

  function mediaForColour(form, optName, value) {
    var data;
    try { data = JSON.parse(form.getAttribute('data-variants') || '[]'); }
    catch (err) { return null; }

    /* Prefer an in-stock variant, but fall back to any match so a sold-out
       colour still shows its photo instead of doing nothing. */
    var spare = null;
    for (var i = 0; i < data.length; i++) {
      var v = data[i];
      if (!v.options || v.options[optName] !== value) continue;
      if (v.mediaIndex === null || v.mediaIndex === undefined) continue;
      if (v.available) return v.mediaIndex;
      if (spare === null) spare = v.mediaIndex;
    }
    return spare;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mg-option]');
    if (!btn) return;
    var optName = btn.getAttribute('data-mg-option');
    if (!isColour(optName)) return;

    var form = btn.closest('[data-mg-product-form]');
    var scope = btn.closest('.mg-pdp') || document;
    var gal = scope.querySelector('[data-mg-gallery]');
    var track = gal && gal.querySelector('[data-mg-track]');
    if (!form || !gal || !track) return;

    var idx = mediaForColour(form, optName, btn.getAttribute('data-value'));
    if (idx === null || idx === undefined) return;

    /* Let mg-theme.js finish its own variant pass first. */
    setTimeout(function () { goTo(gal, track, idx); }, 0);
  });

  /* ---- wiring --------------------------------------------------------- */

  function wire(gal) {
    if (gal.getAttribute('data-mg-pdp-ready') === 'true') return;
    var track = gal.querySelector('[data-mg-track]');
    if (!track) return;
    gal.setAttribute('data-mg-pdp-ready', 'true');

    /* Debounced with a timer rather than requestAnimationFrame: rAF is paused
       in a background tab, which would leave the dots stale on a restored
       page. A 60ms tail also outlasts the tail of a flick. */
    var settle = null;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var idx = scrollIndex(track);
        if (idx !== stated(gal)) paint(gal, idx);
      }, 60);
    }, { passive: true });

    /* Something else set the index - thumbnail, arrow, or a resolved variant.
       Move the scroller to match, unless it is already there. */
    new MutationObserver(function () {
      var idx = stated(gal);
      if (idx !== scrollIndex(track)) glide(track, idx);
    }).observe(gal, { attributes: true, attributeFilter: ['data-index'] });

    /* Keyboard parity with the swipe. */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      var n = slides(track).length;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gal, track, (stated(gal) + 1) % n); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gal, track, (stated(gal) - 1 + n) % n); }
    });

    /* A resize changes what scrollLeft means, so re-anchor on the current slide. */
    var last = track.clientWidth;
    window.addEventListener('resize', function () {
      if (track.clientWidth === last) return;
      last = track.clientWidth;
      glide(track, stated(gal), true);
    });

    var initial = stated(gal);
    paint(gal, initial);
    if (initial !== scrollIndex(track)) glide(track, initial, true);

    /* Full-screen gallery. It uses a second native scroller so the customer
       gets the same momentum and snapping after opening a photo. */
    var lightbox = gal.querySelector('[data-mg-gallery-lightbox]');
    var lightboxTrack = lightbox && lightbox.querySelector('[data-mg-lightbox-track]');
    if (!lightbox || !lightboxTrack) return;

    function openLightbox(idx) {
      idx = wrap(idx, lightboxSlides(lightboxTrack).length);
      paintLightbox(lightbox, idx);
      if (window.MG && window.MG.openPanel) window.MG.openPanel(lightbox);
      else lightbox.hidden = false;
      window.requestAnimationFrame(function () {
        glideLightbox(lightboxTrack, idx, true);
      });
    }

    gal.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-mg-gallery-open]');
      if (!opener || !gal.contains(opener)) return;
      e.preventDefault();
      openLightbox(parseInt(opener.getAttribute('data-index'), 10) || 0);
    });

    lightbox.addEventListener('click', function (e) {
      var step = e.target.closest && e.target.closest('[data-mg-lightbox-step]');
      if (!step) return;
      e.preventDefault();
      var n = lightboxSlides(lightboxTrack).length;
      var idx = wrap(parseInt(lightbox.getAttribute('data-index'), 10) + parseInt(step.getAttribute('data-mg-lightbox-step'), 10), n);
      paintLightbox(lightbox, idx);
      glideLightbox(lightboxTrack, idx);
    });

    var lightboxSettle = null;
    lightboxTrack.addEventListener('scroll', function () {
      clearTimeout(lightboxSettle);
      lightboxSettle = setTimeout(function () {
        paintLightbox(lightbox, lightboxIndex(lightboxTrack));
      }, 60);
    }, { passive: true });

    lightboxTrack.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = lightboxSlides(lightboxTrack).length;
      var step = e.key === 'ArrowRight' ? 1 : -1;
      var idx = wrap(parseInt(lightbox.getAttribute('data-index'), 10) + step, n);
      paintLightbox(lightbox, idx);
      glideLightbox(lightboxTrack, idx);
    });

    /* Closing on the X or Escape returns the large gallery to the photo the
       customer was viewing full screen. */
    new MutationObserver(function () {
      if (!lightbox.hidden) return;
      var idx = parseInt(lightbox.getAttribute('data-index'), 10) || 0;
      goTo(gal, track, idx);
    }).observe(lightbox, { attributes: true, attributeFilter: ['hidden'] });

    var lightboxWidth = lightboxTrack.clientWidth;
    window.addEventListener('resize', function () {
      if (lightbox.hidden || lightboxTrack.clientWidth === lightboxWidth) return;
      lightboxWidth = lightboxTrack.clientWidth;
      glideLightbox(lightboxTrack, parseInt(lightbox.getAttribute('data-index'), 10) || 0, true);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mg-gallery]'), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
